import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { AnnouncementBannerQuery } from "../../types/graphql";
import { useMergePrismicPreviewData } from "gatsby-plugin-prismic-previews";
import { PureAnnouncementBanner } from "./pure-announcement-banner";

export const AnnouncementBanner = () => {
  const data = useStaticQuery<AnnouncementBannerQuery>(graphql`
    query AnnouncementBanner {
      prismicAnnouncementBanner {
        data {
          cta_text
          cta_url {
            url
            target
          }
          subtitle
          title
        }
      }
    }
  `);

  return <PureAnnouncementBanner data={useMergePrismicPreviewData(data)} />;
};
